import script from "./CreateCrossProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCrossProductPopup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__